import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen"
import useHttpUtility from "../utilities/useHttpUtility";
import useFormUtility from "../utilities/useFormUtility";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemSave from "../components/MenuPageItemSave";
import FormFieldText from "../components/FormFieldText";
import FormFieldCheckbox from "../components/FormFieldCheckbox";
import FormFieldSelect from "../components/FormFieldSelect";

export default function PageSettingsWidgetDelivery() {

    const navigate = useNavigate();
    const http = useHttpUtility();
    const formUtility = useFormUtility(null);

    const addressModes = [
        { "name": "Google", "value": 1 },
        { "name": "Manual", "value": 2 },
        { "name": "Google and manual", "value": 3 }
    ];

    useEffect(() => {
        http.get("/api/Settings/Widget/Delivery", (d) => formUtility.setData({ ...d, addressMode: d.addressMode.toString()}));
    }, []);

    return (
        !formUtility.data
            ? <LoadingScreen />
            :
            <div className="page page-settings-widget-delivery">
                <MenuPage>
                    <MenuPageItemDiscard formUtility={formUtility} onClick={() => navigate(`..${window.location.search}`)} />
                    <MenuPageItemSave formUtility={formUtility} onClick={() => http.post("/api/Settings/Widget/Delivery", formUtility.data, (d) => formUtility.setData({ ...d, addressMode: d.addressMode.toString() }))} />
                </MenuPage>
                <div>
                    <FormFieldSelect formUtility={formUtility} field="addressMode" label="Address Mode" options={addressModes} />
                    <FormFieldCheckbox formUtility={formUtility} field="showRates" label="Show Rates" />
                    <FormFieldCheckbox formUtility={formUtility} disabled={!formUtility.data.showRates} field="showAvailableOptions" label="Show Available Options" />
                    <FormFieldCheckbox formUtility={formUtility} field="showInstructions" label="Show Instructions" />
                </div>
                <div>
                    <h2>Translations</h2>
                    <FormFieldText formUtility={formUtility} field="translation.tab" label="Tab" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.addressMode" label="Address Mode" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.addressModeGoogle" label="Address Mode Google" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.addressModeManual" label="Address Mode Manual" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.address" label="Address" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.addressPlaceholder" label="Address Placeholder" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.date" label="Date" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.datePlaceholder" label="Date Placeholder" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.availableOptions" label="Available Options" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.instructions" label="Instructions" max={50} />
                    <FormFieldText formUtility={formUtility} field="translation.instructionsPlaceholder" label="Instructions Placeholder" max={50} />
                </div>
            </div>
    );
}